module.exports = __webpack_public_path__ + "img/characters240On.76e8a14a.svg";